module.exports = __webpack_public_path__ + "8d85e212876eb580cf9fc7c1ede11fe1.MP3";